import React, { useContext } from 'react';
import MenuBar from '../../../../components/MenuBar/MenuBar';
import { WidgetProvider } from '../../WidgetContext';
import PropTypes from 'prop-types';
import { WidgetContainerStyled } from '../../styles';
import { ViewVideoContext } from './context/View.video.context';
import { useSetCurrentWorkspace } from './hooks/useSetCurrentWorkspace';
import { useFetchdata } from './hooks/useFetchData';

const ViewVideo = () => {

  const {
    currentWorkspaceUuid,
    navData, 
    actionsState,
    viewInstance,
    absolutePath 
  } = useContext(ViewVideoContext);


  useFetchdata();
  useSetCurrentWorkspace();

  if (!absolutePath) return null;

  return (
    <WidgetContainerStyled>
      <WidgetProvider value={{
        widgetData: navData.widgetData,
        viewInstance: viewInstance.current,
        actionsState: actionsState,
        currentWorkspaceUuid: currentWorkspaceUuid
      }}>
        {navData.widgetData.menu ? (
          <MenuBar
            key={`menu-${navData.widgetData.menu.id}`}
            menu={navData.widgetData.menu}
            widgetTools={null}
          />
        ) : null}
        {absolutePath ? (
          <video 
            style={{
              borderRadius: '10px',
              width: '100%',
              height: 'auto',
              maxHeight: '100%',
              objectFit: 'contain',
            }}
            ref={viewInstance}
            controls
          >
            <source 
              src={absolutePath} 
              type="video/mp4" 
            />
      Your browser does not support HTML5 video.
          </video>
        ) : (
          <p>Kein Video verfügbar.</p>
        )}
      </WidgetProvider>
    </WidgetContainerStyled>
  );
};


ViewVideo.propTypes = {
  navData: PropTypes.object,
  actionsState: PropTypes.object
};

export default ViewVideo;
